import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

interface AnalogClockProps {
  size?: number;
}

const ClockContainer = styled.div<{ size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border: ${props => props.size > 50 ? 3 : 1}px solid rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  background: rgba(240, 240, 240, 0.4);
  backdrop-filter: blur(25px);
`;

const ClockFace = styled.svg`
  width: 100%;
  height: 100%;
`;

const Hand = styled.line<{ stroke: string; strokeWidth: number }>`
  stroke: ${props => props.stroke};
  stroke-width: ${props => props.strokeWidth};
  stroke-linecap: round;
`;

const Center = styled.circle`
  fill: #333;
`;

const AnalogClock: React.FC<AnalogClockProps> = ({ size = 80 }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const secondAngle = (time.getSeconds() * 6) - 90;
  const minuteAngle = (time.getMinutes() * 6) - 90;
  const hourAngle = ((time.getHours() % 12) * 30 + time.getMinutes() * 0.5) - 90;

  const getHandPosition = (angle: number, length: number) => {
    const radian = (angle * Math.PI) / 180;
    const center = size / 2;
    return {
      x: center + length * Math.cos(radian),
      y: center + length * Math.sin(radian)
    };
  };

  const center = size / 2;
  const hourPos = getHandPosition(hourAngle, size * 0.25);
  const minutePos = getHandPosition(minuteAngle, size * 0.35);
  const secondPos = getHandPosition(secondAngle, size * 0.375);

  return (
    <ClockContainer size={size}>
      <ClockFace>
        {/* Marcas de horas */}
        {[...Array(12)].map((_, i) => {
          const angle = (i * 30) - 90;
          const outer = getHandPosition(angle, size * 0.44);
          const inner = getHandPosition(angle, size * 0.38);
          return (
            <line key={i} x1={inner.x} y1={inner.y} x2={outer.x} y2={outer.y} stroke="#333" strokeWidth={size > 50 ? 1 : 0.5}/>
          );
        })}
        <Hand x1={center} y1={center} x2={hourPos.x} y2={hourPos.y} stroke="#333" strokeWidth={size > 50 ? 3 : 1.5} />
        <Hand x1={center} y1={center} x2={minutePos.x} y2={minutePos.y} stroke="#333" strokeWidth={size > 50 ? 2 : 1} />
        <Hand x1={center} y1={center} x2={secondPos.x} y2={secondPos.y} stroke="#e74c3c" strokeWidth={size > 50 ? 1 : 0.5} />
        <Center cx={center} cy={center} r={size > 50 ? 3 : 1} />
      </ClockFace>
    </ClockContainer>
  );
};

export default AnalogClock;
